module.exports = __webpack_public_path__ + "img/charts.1c9b267d.png";